import { render, staticRenderFns } from "./TabsContent.vue?vue&type=template&id=7e11bf89"
import script from "./TabsContent.vue?vue&type=script&lang=js"
export * from "./TabsContent.vue?vue&type=script&lang=js"
import style0 from "./TabsContent.vue?vue&type=style&index=0&id=7e11bf89&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports